export default {
	sec_01: {
		title: {
			one: 'How to use',
			two: 'offline',
			three: 'merchants',
		},
		desc: {
			one: 'Customers can quickly make payments themselves.',
			two: 'Please try JP WOLRD Pay, which allows you to pay immediately with a',
			three: 'mobile phone without cash or card.',
		},
		btn: {
			one: 'Sign up',
			two: 'Login',
		},
	},
	sec_02: {
		title: {
			one: 'JP WOLRD Payment method using',
		},
		step: {
			one: {
				one: 'Select',
				two: 'JP WOLRD Pay',
				three: 'on your phone and use it.',
			},
			two: {
				one: 'Select your wallet',
				two: 'and then select the Offline Store Payment.',
			},
			three: {
				one: 'if you scan the QR code on the kiosk,',
				two: 'the payment is complete.',
			},
		},
	},
	sec_04: {
		title: 'Welcome to the future currency system',
		cards: {
			one: {
				title: 'Secure payment',
				description: {
					one: 'Your information will not be remembered',
					two: 'when you make an offline payment.',
				},
			},
			two: {
				title: 'At a nearby merchants',
				description: {
					one: 'Find merchants with JP WOLRD Pay anytime,',
					two: 'anywhere and use it.',
				},
			},
			three: {
				title: 'Without cash',
				description: {
					one: 'Do you still carry cash?',
					two: 'Use JP WOLRD Pay on your phone right away.',
				},
			},
		},
	},
	sec_05: {
		title: 'Sellers can access easily too',
		desc: {
			one: 'All you have to do is register the items for sale at the JP WOLRD Pay kiosk.',
			two: 'The payment will be made by JP WOLRD Pay Kiosk.',
		},
	},
};
